// Since Vite 8, a default import of a CommonJS package gets what Node gives it:
// the whole module.exports. Packages compiled from ESM put their export on
// `exports.default`, so their default import arrives as {default: ...} and
// calling it throws. This unwraps that, and passes anything else through.
export default function cjsDefault<T>(imported: T): T {
    return (imported as {default?: T}).default ?? imported;
}
